import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.6_@parcel+watcher@2.5.1_@types+node@24.0.10_@vercel+blob@1.1.1_@vue+compiler-sfc@3._66ubvd4ctn4l2rstl4hjlmicsq/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}